// WARNING!!! DO NOT ADD ANY BARCODE IDs to this file!!!
// By adding a barcode ID, we are passing patient PII/PHI to client that can be retrieved without authentication. 
// TODO: REMOVE this functionality all together. This was added as a bypass (in 2023) for customers that are NTO Ro customers. 
const roTests = {
  defaultDOB: '1990-01-01',
  boxes: [],
}

export default roTests
